module.exports = "pegasus_template/assets/square-tumblr.png";